import React from 'react'
import ReactDOM from 'react-dom/client'
import type { CatalogBootstrap, CatalogResponse } from './ModaShowcase'

const root = ReactDOM.createRoot(document.getElementById('root')!)
const path = window.location.pathname.replace(/\/+$/, '') || '/'
const isModaPage = window.location.hostname.toLowerCase() === 'moda.zyncbio.app'
  || path === '/moda'
  || path === '/p/moda-na-promo'

const fontStylesheet = document.createElement('link')
fontStylesheet.rel = 'stylesheet'
fontStylesheet.media = 'print'
fontStylesheet.onload = () => { fontStylesheet.media = 'all' }
fontStylesheet.href = isModaPage
  ? 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&icon_names=lock,search,search_off,swap_vert,verified&family=Playfair+Display:ital,wght@0,400;1,400&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap'
  : 'https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&family=Inter:wght@400;500;600;700&family=Manrope:wght@400;500;600;700;800&family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&icon_names=add,ads_click,amp_stories,archive,arrow_forward,attach_file,auto_awesome,auto_fix_high,bolt,cached,campaign,chat,chat_bubble_outline,check,check_circle,chevron_left,chevron_right,close,collections,content_copy,dashboard,delete_forever,edit_note,error,event,event_repeat,expand_less,expand_more,extension,favorite,forum,group,groups,hourglass_top,image,info,inventory_2,key,layers,link,link_off,local_offer,lock,mail,mark_chat_read,monitoring,more_horiz,more_vert,movie,notifications,open_in_new,pause_circle,payments,perm_media,person,person_add,photo,photo_camera,play_arrow,play_circle,progress_activity,prompt_suggestion,publish,queue,refresh,schedule,science,search,search_off,settings,shield,shopping_bag,storefront,swap_vert,sync,thumb_down,thumb_up,tune,upload,verified,verified_user,view_carousel,view_list,visibility,warning,wifi_off,zoom_in&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600;1,700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap'
document.head.appendChild(fontStylesheet)

if (isModaPage) {
  document.title = 'Moda na Promo — curadoria de moda feminina'
  const description = document.querySelector<HTMLMetaElement>('meta[name="description"]')
  if (description) description.content = 'Uma curadoria de moda feminina com ofertas selecionadas. Confira preços e disponibilidade diretamente na loja.'
}

const renderLoadError = () => {
  root.render(<main style={{ padding: 24, fontFamily: 'sans-serif' }}>Não foi possível carregar esta página. Atualize para tentar novamente.</main>)
}

if (isModaPage) {
  const catalogPromise: Promise<CatalogBootstrap> = fetch('/api/pages/moda-na-promo', { credentials: 'include' })
    .then(async (response) => {
      const payload = await response.json().catch(() => ({})) as { error?: string }
      if (!response.ok) throw new Error(payload.error || 'Não foi possível carregar a vitrine.')
      const data = payload as unknown as CatalogResponse
      const featured = data.products.find((product) => product.story_art_url) || data.products.find((product) => product.images?.[0])
      const imageUrl = featured?.story_art_url || featured?.images?.[0]
      if (imageUrl) {
        const preload = document.createElement('link')
        preload.rel = 'preload'
        preload.as = 'image'
        preload.href = imageUrl
        preload.setAttribute('fetchpriority', 'high')
        document.head.appendChild(preload)
      }
      return { data }
    })
    .catch((error) => ({ error: error instanceof Error ? error.message : 'Não foi possível carregar a vitrine.' }))

  void Promise.all([import('./moda.css'), import('./ModaShowcase')]).then(([, { default: Page }]) => {
    root.render(<React.StrictMode><Page initialDataPromise={catalogPromise} /></React.StrictMode>)
  }).catch(renderLoadError)
} else {
  void Promise.all([import('./styles.css'), import('./App')]).then(([, { default: Page }]) => {
    root.render(<React.StrictMode><Page /></React.StrictMode>)
  }).catch(renderLoadError)
}
